import React from 'react'
import { Region } from '@enonic/react-components';

import Section from '../../../react4xp/components/Section'
import RichText from '../../../react4xp/components/RichText'
import LandingPageHero from '../../../react4xp/components/LandingPageHero'

function LandingPageLayout({ title, intro, image, video, text, bgColor, isWhite, regions }) {

    return (
        <div className='page-landing-page'>
            <LandingPageHero
                bgColor={bgColor}
                isWhite={isWhite}
                title={title}
                image={image}
                video={video}
                content={intro}
            />

            <Region name={regions.main.name} regionData={regions.main} />

            {
                text &&
                <Section className='page-landing-page__body'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-md-10 col-lg-8 offset-lg-1 col-xl-6 offset-xl-2 page-landing-page__body__content'>

                                <RichText
                                    content={text}
                                />

                            </div>
                        </div>
                    </div>
                </Section>
            }
        </div>
    )
}

export default (props) => <LandingPageLayout {...props} />
